export const HIDE_ANSWER_MODAL = "HIDE_ANSWER_MODAL";
export const SHOW_ANSWER_MODAL = "SHOW_ANSWER_MODAL";

export const HIDE_MENU_DRAWER = "HIDE_MENU_DRAWER";
export const SHOW_MENU_DRAWER = "SHOW_MENU_DRAWER";

export const HIDE_QUESTION_MODAL = "HIDE_QUESTION_MODAL";
export const SHOW_QUESTION_MODAL = "SHOW_QUESTION_MODAL";